import React from 'react';
import { useSelector } from 'react-redux';

import { Button, Layout } from 'antd';
import { strings } from '../../localization';
import { getUserEmail } from '../../data/auth/selectors';

const InvitationWrongUserScreen = (props) => {
    const { logout } = props;
    const currentEmail = useSelector(getUserEmail);

    return (
        <div style={{display:"flex"}}>
            <Layout style={{
                margin: 80,
                paddingTop: 40,
                paddingBottom: 20,
                width: '40%',
                alignItems: 'center',
                alignSelf: 'center',
                border: '3px solid #cf1322',
                backgroundColor: 'white',
            }}>
                <p style={{marginBottom: 30, textAlign: 'center'}}>
                    {strings.homes.wrongUserInvitation1}<b>{currentEmail}</b>{strings.homes.wrongUserInvitation2}
                </p>
                <Button
                    key='wrong-user-logout'
                    type='primary'
                    onClick={logout}
                >
                    {strings.logoutLink}
                </Button>
            </Layout>
        </div>
    );
}

export default InvitationWrongUserScreen;
